// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__1BPlo","buttonRow":"styles_buttonRow__1LLhO","blackText":"styles_blackText__1nUbW","error":"styles_error__7j77G"};